import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { apolloClient } from "./apolloClient";
import { ApolloProvider } from "@apollo/client";
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
const theme = createTheme({
  typography: {
    fontFamily: ['"Inter"', "Helvetica", "Arial", "sans-serif"].join(","),
  },
});
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ApolloProvider client={apolloClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <App />
        </ThemeProvider>
      </ApolloProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
